export const isUndefinedOrNull = (val) => {
  return val === undefined || val === null;
};

export const isEmptyVar = (val) => {
  return val === undefined || val === null || val.toString().trim() === '';
};
